// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1VejN","choiceBoxes":"toolbarselects_choiceBoxes__144oI","simpleField":"toolbarselects_simpleField__XGZ9z"};